// React
import React from "react";
// Components
import Page from "common/ui/components/page/Page";
import PageHeading from "common/ui/components/page/PageHeading";
import PageContainer from "common/ui/components/page/PageContainer";
import ReportDatePicker from "common/ui/components/datePicker/ReportDatePicker";
// Helpers
import NamingHelper from "common/utils/namingHelper";
import DateHelper from "common/utils/DateHelper";
//-- Styles -------------------------------------------------------------------------------------------------------------------------------
import styles from "./StatsReportView.less";
//-- Component -------------------------------------------------------------------------------------------------------------------------------
export default class StatsReportView extends React.Component {
    render() {
        let { fromDate, toDate, isFetching, isError } = this.props;
        let ranges = {
            'Last 7 Days': DateHelper.getLast7Days(),
            'Last 30 Days': DateHelper.getLast30Days(),
            'This Month': DateHelper.getThisMonth(),
            'Last Month': DateHelper.getLastMonth(),
            'Last 90 Days': DateHelper.getLast90Days()
        };
        let datePickerComponent = (React.createElement(ReportDatePicker, { fromDate: fromDate, toDate: toDate, isFetching: isFetching, dateRange: ranges, onSelect: (from, to) => this.props.datePick(from, to) }));
        //-- Return
        return (React.createElement(Page, null,
            React.createElement(PageHeading, { reportName: NamingHelper.officeOverview, datePicker: datePickerComponent }),
            isError && React.createElement("div", { className: styles.container },
                React.createElement("div", { className: styles.noResultsFound },
                    React.createElement("div", { className: styles.noResultsFoundText }, "No results found"))),
            !isError && this.renderContents(isFetching)));
    }
    renderContents(isFetching) {
        return (React.createElement(PageContainer, { isFetching: isFetching },
            this.props.pageTabsElement,
            this.props.children));
    }
}
